export const createSearchSlice = (set) => ({
  searchActive: false,
  toggleSearchActive: () =>
    set(({ searchActive }) => ({ searchActive: !searchActive })),
  closeSearch: () => set({ searchActive: false }),
});

